import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import style from "./log.module.scss";
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import Pagination from "../pagination/pagination";
import CalendarModal from "../modalCalendar/modalCalendar";
import LogCard from "./logCard/logCard"
import momentJalaali from 'moment-jalaali';
import { getLogList } from "../../actions/APIcalls"

let statics = [{ title: 'امروز', number: '469' }, { title: 'هفته جاری', number: '1876' }, { title: 'هفته گذشته', number: '21876' }, { title: 'ماه جاری', number: '4654987' }]

const Log = (props) => {

    const [openCalendarModal, setOpenCalendarModal] = useState(false)
    const [dateRangeLabel, setDateRangeLabel] = useState('ماه اخیر')
    const [logList, setLogList] = useState({
        logListPageCount: 10,
        logListCount: 0,
        list: [],
        error: ''
    })

    useEffect(() => {
        getLog()
    }, [])

    const setDateRange = (range) => {
        let urlFrom = getFromUrl("from");
        let urlTo = getFromUrl("to");
        range.start && (urlFrom = momentJalaali(range.start))
        range.end && (urlTo = momentJalaali(range.end))
        setToUrl(urlFrom, "from");
        setToUrl(urlTo, "to");
    }

    const getFromUrl = (param) => {
        const defaultParams = {
            countInPage: 10,
            page: 1,
            from: momentJalaali().subtract(30, "day"),
            to: momentJalaali()
        }
        let url = new URLSearchParams(window.location.search);
        if (url.get(param)) {
            if (url.get(param) === "true" || url.get(param) === "false") {
                return url.get(param) === "true" ? true : false;
            } else {

                return url.get(param)
            }
        } else {
            return defaultParams[param];
        }
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        getLog();
    }

    const getLog = async () => {
        let reqObject = {
            countInPage: getFromUrl("countInPage") ? getFromUrl("countInPage") : 10,
            page: getFromUrl("page") ? getFromUrl("page") : 1,
            from: getFromUrl("from") ? getFromUrl("from") : momentJalaali().subtract(30, "day"),
            to: getFromUrl("to") ? getFromUrl("to") : momentJalaali()
        }
        let res = await getLogList(reqObject)
        console.log(res, 'res');
        let tmpLogList = logList
        if (res && res.data) {
            tmpLogList.list = res.data.List
            tmpLogList.logListCount = res.data.logCount
            tmpLogList.logListPageCount = res.data.maximum_page
        } else {
            tmpLogList.error = 'داده‌ای برای نمایش وجود ندارد'
        }
        setLogList({ ...tmpLogList })
    }

    return (
        <div className={style.wrapper}>
            <h3 className={style.subDescription}><span className={style.warningIcon}>n</span>آمار فعالیت‌های ربات برای ۳۰ روز گذشته ذخیره و نمایش داده می‌شود.</h3>
            <div className={style.calendarModalWrapper}>
                <div className={style.calendarModalWrapperInner}>
                    <CalendarModal
                        label={dateRangeLabel}
                        dateLabel={(label) => {
                            setDateRangeLabel(label)
                        }}
                        setRange={(range) => {
                            setDateRange(range)
                        }}
                        // فعلا بازه زمانی نداریم 
                        // value={{ start: getFromUrl("from"), end: getFromUrl("to") }}
                        value={{ start: momentJalaali().subtract(30, "day"), end: momentJalaali() }}
                        openModal={openCalendarModal}
                    />
                </div>
            </div>

            {/* !  فعلا آمار ورود به باکس نداریم  */}
            {/* <h4 className={style.boxTitle}>آمار ورود به باکس</h4>

            <div className={style.staticsWrapper}>
                {statics.map((item, index) => <div key={index} className={style.staticIcon}>
                    <div className={style.staticIconWrapper}><div className={style.imgIcon}></div></div>
                    <div className={style.staticLabelWrapper}>
                        <p className={style.firstTitle}>{item.title}</p>
                        <p className={style.secondTitle}>{toPersianNumber(numberWithCommas(item.number))}</p>
                    </div>
                </div>)}
            </div> */}

            <div className={style.paginationWrapper}>
                <div className={style.pagination}>
                    <div className={style.Dropdown}>
                        {!logList.error && <Pagination
                            tag="page"
                            currentPage={parseInt(getFromUrl("page"))}
                            pageCount={logList.logListPageCount}
                            setPage={setToUrl}
                        />}

                        <div className={style.gap20}></div>

                        <TinyDropdown
                            placeholder={10}
                            dropdownList={["10", "25", "50", "75", "100"]}
                            selected={selected => {
                                setToUrl(selected, 'countInPage')
                            }}
                            selectedItem={getFromUrl('countInPage')}
                        />
                        <div className={style.label}>تعداد نمایش در صفحه</div>
                        <div className={style.verticalLine}></div>
                        <div
                            className={style.variantCount}>{typeof logList.logListCount !== 'undefined' ? toPersianNumber(logList.logListCount) + " نتیجه" : ""}</div>
                    </div>
                </div>
            </div>

            {logList.error && <h3>{logList.error}</h3>}
            <div className={style.listWrapper}>
                {logList.list ? logList.list.map((listItem, index) => <LogCard data={listItem} />) : null}
            </div>

            <div className={style.paginationTwo}>
                {!logList.error && <Pagination
                    tag="page"
                    currentPage={parseInt(getFromUrl("page"))}
                    pageCount={logList.logListPageCount}
                    setPage={setToUrl}
                />}
            </div>

        </div>
    )
}

export default withRouter(Log);



